var _circle, _mask, _path, _mask2, _path2, _mask3, _path3, _circle2, _circle3, _path4, _circle4, _circle5, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 9,
    r: 5.5,
    stroke: "currentColor",
    fill: "transparent"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "people_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.778 6.043a5.5 5.5 0 10.34 6.446A5.973 5.973 0 019 9c0-1.075.283-2.084.778-2.957z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.778 6.043l.87.494.336-.593-.429-.53-.777.63zm.34 6.446l.839.544.37-.572-.396-.554-.813.582zM5.5 5A4.49 4.49 0 019 6.672l1.555-1.258A6.49 6.49 0 005.5 3v2zM1 9.5A4.5 4.5 0 015.5 5V3A6.5 6.5 0 00-1 9.5h2zM5.5 14A4.5 4.5 0 011 9.5h-2A6.5 6.5 0 005.5 16v-2zm3.779-2.056A4.496 4.496 0 015.5 14v2c2.289 0 4.3-1.184 5.457-2.967l-1.678-1.088zm1.652-.037A4.973 4.973 0 0110 9H8c0 1.517.484 2.924 1.305 4.07l1.626-1.163zM10 9c0-.898.236-1.737.648-2.463l-1.74-.987A6.972 6.972 0 008 9h2z",
    fill: "currentColor",
    mask: "url(#people_svg__a)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "people_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9 18c.066-.215.1-.438.1-.667C19 15.493 16.761 14 14 14s-5 1.492-5 3.333c0 .229.034.452.1.667h9.8z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9 18v1h.74l.217-.709L18.9 18zm-9.8 0l-.957.291.216.709H9.1v-1zm8.9-.667c0 .127-.019.252-.057.376l1.914.582a3.28 3.28 0 00.143-.958h-2zM14 15c1.21 0 2.262.329 2.98.808.727.484 1.02 1.043 1.02 1.525h2c0-1.358-.826-2.466-1.91-3.189C17 13.417 15.55 13 14 13v2zm-4 2.333c0-.482.293-1.04 1.02-1.525C11.737 15.33 12.79 15 14 15v-2c-1.55 0-3 .417-4.09 1.144-1.084.723-1.91 1.83-1.91 3.19h2zm.057.376a1.278 1.278 0 01-.057-.376H8c0 .33.05.651.143.958l1.914-.582zM9.1 19h9.8v-2H9.1v2z",
    fill: "currentColor",
    mask: "url(#people_svg__b)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "people_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17.333c0 .229.034.452.1.667h-9a2.281 2.281 0 01-.1-.667C1 15.493 3.239 14 6 14c1.98 0 3.69.767 4.5 1.879-.32.44-.5.933-.5 1.454z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1 18v1h1.35l-.393-1.291L10.1 18zm-9 0l-.957.291L.36 19H1.1v-1zm9.4-2.121l.808.589.43-.59-.43-.588-.808.589zm.557 1.83a1.278 1.278 0 01-.057-.376H9c0 .33.05.651.143.958l1.914-.582zM7.333 19H10.1v-2H7.333v2zM1.1 19h6.233v-2H1.1v2zM0 17.333c0 .33.05.651.143.958l1.914-.582A1.28 1.28 0 012 17.333H0zM6 13c-1.55 0-3 .417-4.09 1.144-1.084.723-1.91 1.83-1.91 3.19h2c0-.483.293-1.042 1.02-1.526C3.737 15.33 4.79 15 6 15v-2zm5.308 2.29C10.254 13.843 8.19 13 6 13v2c1.768 0 3.125.69 3.692 1.468l1.616-1.178zM11 17.333c0-.281.095-.573.308-.865L9.692 15.29C9.265 15.876 9 16.572 9 17.333h2z",
    fill: "currentColor",
    mask: "url(#people_svg__c)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 9.5,
    r: 0.5,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 9.5,
    r: 0.5,
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 11.5l.507.203a2 2 0 001.486 0L7 11.5",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 9.5,
    r: 0.5,
    fill: "currentColor"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 9.5,
    r: 0.5,
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11.5l.507.203a2 2 0 001.486 0l.507-.203",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}

export default __webpack_public_path__ + "static/media/people.6a7d08c4.svg";
export { SvgPeople as ReactComponent };